import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";

import ScheduleEvents from "./ScheduleEvents";
import { useParams } from "react-router-dom";
import { useSearchParams } from "@/helpers/useSearchParams";

const ScheduleEventsPage = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { deviceSerialNumber } = useParams();
  const { viewType } = useSearchParams();

  return (
    <>
      <BreadCrumbs noTranslate pageName={t({ defaultMessage: "排程管理" })} />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">
          {t({ defaultMessage: "排程管理" })}
        </Typography>
      </div>
      <ScheduleEvents
        viewType={viewType ? +viewType : undefined}
        deviceSerialNumber={deviceSerialNumber}
      />
    </>
  );
};

export default ScheduleEventsPage;
